import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxDynamicTableComponent } from './ngx-dynamic-table.component';



@NgModule({
  declarations: [
    NgxDynamicTableComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    NgxDynamicTableComponent
  ]
})
export class NgxDynamicTableModule { }
